import React, { useState } from "react";
import Input from "../form/Input"; import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api";

export default function LoginForm({category,redirect="/"}) {
  const navigate=useNavigate()
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error("Please fill in all fields!");
      return;
    }

    try {
      setLoading(true);
      const { data } = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}${category}/login`,
        formData
      );

      toast.success("Login successful!");
      console.log("User Data:", data);

      localStorage.setItem("authToken", data.token);
      navigate(redirect)
      
    } catch (error) {
      toast.error(error.response?.data?.message || "Invalid credentials!");
    } finally {
      setLoading(false);
    }
    setFormData({ email: "", password: "" });
  };

  return (
    <>
    
      <form onSubmit={handleSubmit} className="flex flex-wrap">
        <Input md={12} id="email" name="email" type="email" placeholder="Enter your email" value={formData.email} onChange={handleChange} />
        <Input md={12} id="password" name="password" type="password" placeholder="Enter your password" value={formData.password} onChange={handleChange} />

        <button
          type="submit"
          disabled={loading}
          className={`w-full bg-indigo-600 text-white py-2 mt-4 rounded-md transition ${loading ? "opacity-50 cursor-not-allowed" : "hover:bg-indigo-700"}`}
        >
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
      {
        category=='students' &&
      <p className="mt-5 text-center text-sm text-gray-500">
        Dont't have Account?
        <Link
          to="/registration"
          className="font-semibold ps-1 text-indigo-600 hover:text-indigo-500"
          >
           Register Here
        </Link>
        <Link
  to="/forgot-password"
  className="text-sm text-indigo-600 hover:underline block mt-2"
>
  Forgot Password?
</Link>

      </p>
        }
    </>
  );
}
